import React, { useState } from 'react';
import { REFERENCE_NOTES_HINT, REFERENCE_NOTES_LABEL } from './reference_notes';
import FaIcon from '../../../components/FaIcon';

/** One internal note: its title; a click shows the body. Every click stops here, so a note never accepts a suggestion. */
function ReferenceNote({ note }) {
    const [open, set_open] = useState(false);
    const toggle = (e) => { e.stopPropagation(); e.preventDefault(); set_open((o) => !o); };
    return (
        <div data-reference-note={note.id} style={{ marginTop: 3 }}>
            <span onClick={toggle} style={{ cursor: 'pointer', color: '#6b5a1e', fontSize: 11.5 }} title={open ? 'Hide' : 'Show the note'}>
                <FaIcon name={open ? 'caret-down' : 'caret-right'} /> {note.module ? <b style={{ fontWeight: 600 }}>{note.module} · </b> : null}{note.title || note.body.slice(0, 80)}
            </span>
            {open ? <div style={{ fontSize: 11.5, color: '#5d4e1a', whiteSpace: 'pre-wrap', margin: '3px 0 2px 14px', lineHeight: 1.4 }}>{note.body}</div> : null}
        </div>
    );
}

/** The internal reference notes beside a reply suggestion — never inside it (Nikhil 2026-10-22). Renders nothing without notes. */
export default function ReferenceNotes({ notes }) {
    if (!notes || notes.length === 0) return null;
    return (
        <div data-reference-notes onClick={(e) => e.stopPropagation()} title={REFERENCE_NOTES_HINT}
            style={{ marginTop: 6, padding: '6px 12px', background: '#fffaf0', border: '1px dashed #ecd9a6', borderRadius: 10, cursor: 'default' }}>
            <div style={{ fontSize: 10.5, color: '#8a6d1d', textTransform: 'uppercase', letterSpacing: 0.5 }}><FaIcon name='lock' label='internal' /> {REFERENCE_NOTES_LABEL}</div>
            {notes.map((n) => <ReferenceNote key={n.id} note={n} />)}
        </div>
    );
}
